module.exports = __webpack_public_path__ + "static/media/case3A.91dbfcf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case3A.mp4
// module id = Z7/P
// module chunks = 0